import { createSlice } from '@reduxjs/toolkit';
import ISliceState from '../../../../interface/core/ISliceState';
import { sliceStateStatus } from '../../../../Core';

import { 
  settingsIndex, 
  settingsReset,
  brandsIndex,
  brandmodelsIndex,
  dictionaryIndex
} from './settingsActions'

const initialState: ISliceState = {
  data: [],
  status: sliceStateStatus.idle
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(settingsReset, () => {
        return initialState;
      })
      .addCase(settingsIndex.fulfilled, (state, action) => {
        state.data = action.payload.data; 
        state.status = sliceStateStatus.fulfilled; 
      })
      .addCase(settingsIndex.pending, (state, action) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(settingsIndex.rejected, (state, action) => {
        state.status = sliceStateStatus.rejected;
      })

      .addCase(brandsIndex.fulfilled, (state, action) => {
        state.data = action.payload.data; 
        state.status = sliceStateStatus.fulfilled; 
      })
      .addCase(brandsIndex.pending, (state, action) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(brandsIndex.rejected, (state, action) => {
        state.status = sliceStateStatus.rejected;
      })

      .addCase(brandmodelsIndex.fulfilled, (state, action) => {
        state.data = action.payload.data; 
        state.status = sliceStateStatus.fulfilled; 
      })
      .addCase(brandmodelsIndex.pending, (state, action) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(brandmodelsIndex.rejected, (state, action) => {
        state.status = sliceStateStatus.rejected;
      })

      .addCase(dictionaryIndex.fulfilled, (state, action) => {
        //state.data = action.payload.data; 
        state.status = sliceStateStatus.fulfilled; 
      })
      .addCase(dictionaryIndex.pending, (state, action) => {
        state.status = sliceStateStatus.pending;
      })
      .addCase(dictionaryIndex.rejected, (state, action) => {
        state.status = sliceStateStatus.rejected;
      })
  },
});

export default settingsSlice.reducer;